@if (isGalleryViewTypeFirst || isDeviceMobile) {
    <swiper
        class="default-swiper product-card-swiper"
        [ngClass]="{ 'with-bottom-navigation': isHasBottomSpace }"
        [config]="swiperConfig"
        style="--swiper-navigation-color: {{
            themeColorCss(gallerySettings.buttonColor)
        }}; --swiper-pagination-color: {{ themeColorCss(gallerySettings.paginationColor) }}"
        [rewind]="true"
        [navigation]="true"
        [pagination]="{ clickable: true, dynamicBullets: true }"
        [grabCursor]="true"
        [allowTouchMove]="false"
        (swiper)="setSwiper($event)"
        [spaceBetween]="0"
        [slidesPerView]="1"
        [autoHeight]="data.cardSettings.gallery.aspectRatio === aspectRatio.default ? true : false"
    >
        @for (image of cardImages; track $index; let i = $index) {
            <ng-template swiperSlide>
                @if (data.cardSettings.gallery.aspectRatio !== aspectRatio.default) {
                    <div
                        #resizeBox
                        mwlResizable
                        (resizeStart)="onResizeStart($event, resizeBox)"
                        (resizing)="onResizing($event, resizeBox)"
                        (resizeEnd)="onResizeEnd($event, resizeBox, i)"
                        class="image-wrapper imageWrapper resizeble"
                        [style.paddingTop.%]="getImagePaddingTop(cardImages[0])"
                    >
                        <picture [spFallbackImg]="formatImageFallbackURL(image)">
                            @if (image?.srcSets?.length) {
                                @for (source of image.srcSets; track source) {
                                    <source [srcset]="source.url" [media]="source.media" />
                                }
                            }
                            <img
                                #imageRef
                                class="gridImage"
                                (load)="resizeOnload($event.target, resizeBox, i)"
                                [src]="formatImageURL(image)"
                                [alt]="image?.alt"
                                [style.objectPosition]="
                                    (image?.backgroundPositionX || 50) + '% ' + (image?.backgroundPositionY || 50) + '%'
                                "
                                (mousedown)="mouseDown($event, image)"
                                (mousemove)="move($event, imageRef)"
                                (mouseleave)="mouseUp(i)"
                                (mouseup)="mouseUp(i)"
                            />
                        </picture>
                        @if (data.cardSettings.gallery.aspectRatio === aspectRatio.manual) {
                            <div class="dragHandle bottom" mwlResizeHandle [resizeEdges]="{ bottom: true }">
                                <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g>
                                        <path
                                            d="M8.7071 15.6066C8.51956 15.7941 8.26519 15.8995 7.99998 15.8995C7.73476 15.8995 7.48042 15.7941 7.29288 15.6066L5.17156 13.4853C5.03195 13.3455 4.93688 13.1674 4.89837 12.9736C4.85986 12.7798 4.87963 12.5789 4.95519 12.3963C5.00566 12.275 5.07913 12.1645 5.17156 12.0711C5.35906 11.884 5.61311 11.779 5.87796 11.779L6.99943 11.779L7.00085 10C6.99854 9.86724 7.02271 9.73535 7.07192 9.61202C7.12113 9.48869 7.19441 9.3764 7.28749 9.28169C7.38056 9.18699 7.49155 9.11175 7.614 9.0604C7.73646 9.00905 7.86792 8.98263 8.0007 8.98263C8.13348 8.98263 8.26493 9.00906 8.38739 9.06041C8.50984 9.11176 8.62085 9.18698 8.71393 9.28168C8.807 9.37639 8.88029 9.48869 8.9295 9.61202C8.97871 9.73535 9.00286 9.86724 9.00055 10L8.99984 11.7783L10.1213 11.7783C10.3191 11.7784 10.5124 11.837 10.6768 11.9469C10.8412 12.0568 10.9693 12.2129 11.045 12.3956C11.1207 12.5783 11.1405 12.7793 11.102 12.9733C11.0634 13.1672 10.9682 13.3454 10.8284 13.4853L8.7071 15.6066ZM8.0007 6.99985C7.73554 6.99981 7.48124 6.89446 7.29374 6.70696C7.10625 6.51946 7.00089 6.26516 7.00085 6L7.00014 4.22167L5.87867 4.22167C5.68092 4.22164 5.48761 4.16299 5.3232 4.05312C5.15878 3.94325 5.03063 3.78708 4.95495 3.60438C4.87927 3.42168 4.85946 3.22067 4.89801 3.02672C4.93657 2.83276 5.03176 2.65458 5.17156 2.51472L7.29288 0.393397C7.48042 0.20586 7.73478 0.100513 8 0.100513C8.26521 0.100513 8.51956 0.20586 8.70709 0.393397L10.8284 2.51472C10.9679 2.65457 11.0629 2.83261 11.1013 3.02638C11.1398 3.22015 11.12 3.42097 11.0444 3.60349C10.9688 3.78602 10.8409 3.94206 10.6767 4.05195C10.5126 4.16185 10.3196 4.22065 10.122 4.22096L9.00055 4.22096L9.00055 6C9.00051 6.26516 8.89516 6.51946 8.70766 6.70696C8.52016 6.89446 8.26586 6.99981 8.0007 6.99985Z"
                                            fill="white"
                                        />
                                    </g>
                                </svg>
                            </div>
                        }
                    </div>
                }
                @if (data.cardSettings.gallery.aspectRatio === aspectRatio.default) {
                    <div class="image-wrapper imageWrapper">
                        <picture [spFallbackImg]="formatImageFallbackURL(image)">
                            <img class="default-image" [src]="formatImageURL(image)" [alt]="image?.alt" />
                        </picture>
                    </div>
                }
            </ng-template>
        }
    </swiper>
}
@if (isGalleryViewTypeSecond && !isDeviceMobile) {
    @if (thumbsSwiper) {
        <swiper
            class="product-card-swiper"
            [config]="thumbsParentConfig"
            style="--swiper-navigation-color: {{ themeColorCss(gallerySettings.buttonColor) }}"
            [loop]="true"
            [loopedSlides]="loopedSlides"
            [navigation]="true"
            [grabCursor]="true"
            [spaceBetween]="0"
            [slidesPerView]="1"
            [allowTouchMove]="false"
            (swiper)="setSwiper($event)"
            [autoHeight]="data.cardSettings.gallery.aspectRatio === aspectRatio.default ? true : false"
        >
            @for (image of cardImages; track $index; let i = $index) {
                <ng-template swiperSlide>
                    @if (data.cardSettings.gallery.aspectRatio !== aspectRatio.default) {
                        <div
                            #resizeBox
                            mwlResizable
                            (resizeStart)="onResizeStart($event, resizeBox)"
                            (resizing)="onResizing($event, resizeBox)"
                            (resizeEnd)="onResizeEnd($event, resizeBox, i)"
                            class="image-wrapper imageWrapper resizeble"
                            [style.paddingTop.%]="getImagePaddingTop(cardImages[i])"
                        >
                            <picture [spFallbackImg]="formatImageFallbackURL(image)">
                                @if (image?.srcSets?.length) {
                                    @for (source of image.srcSets; track source) {
                                        <source [srcset]="source.url" [media]="source.media" />
                                    }
                                }
                                <img
                                    #imageRef
                                    class="gridImage"
                                    [src]="formatImageURL(image)"
                                    [alt]="image?.alt"
                                    [style.objectPosition]="
                                        (image?.backgroundPositionX || 50) +
                                        '% ' +
                                        (image?.backgroundPositionY || 50) +
                                        '%'
                                    "
                                    (mousedown)="mouseDown($event, image)"
                                    (mousemove)="move($event, imageRef)"
                                    (mouseleave)="mouseUp(i)"
                                    (mouseup)="mouseUp(i)"
                                />
                            </picture>
                            @if (data.cardSettings.gallery.aspectRatio === aspectRatio.manual) {
                                <div class="dragHandle bottom" mwlResizeHandle [resizeEdges]="{ bottom: true }">
                                    <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <g>
                                            <path
                                                d="M8.7071 15.6066C8.51956 15.7941 8.26519 15.8995 7.99998 15.8995C7.73476 15.8995 7.48042 15.7941 7.29288 15.6066L5.17156 13.4853C5.03195 13.3455 4.93688 13.1674 4.89837 12.9736C4.85986 12.7798 4.87963 12.5789 4.95519 12.3963C5.00566 12.275 5.07913 12.1645 5.17156 12.0711C5.35906 11.884 5.61311 11.779 5.87796 11.779L6.99943 11.779L7.00085 10C6.99854 9.86724 7.02271 9.73535 7.07192 9.61202C7.12113 9.48869 7.19441 9.3764 7.28749 9.28169C7.38056 9.18699 7.49155 9.11175 7.614 9.0604C7.73646 9.00905 7.86792 8.98263 8.0007 8.98263C8.13348 8.98263 8.26493 9.00906 8.38739 9.06041C8.50984 9.11176 8.62085 9.18698 8.71393 9.28168C8.807 9.37639 8.88029 9.48869 8.9295 9.61202C8.97871 9.73535 9.00286 9.86724 9.00055 10L8.99984 11.7783L10.1213 11.7783C10.3191 11.7784 10.5124 11.837 10.6768 11.9469C10.8412 12.0568 10.9693 12.2129 11.045 12.3956C11.1207 12.5783 11.1405 12.7793 11.102 12.9733C11.0634 13.1672 10.9682 13.3454 10.8284 13.4853L8.7071 15.6066ZM8.0007 6.99985C7.73554 6.99981 7.48124 6.89446 7.29374 6.70696C7.10625 6.51946 7.00089 6.26516 7.00085 6L7.00014 4.22167L5.87867 4.22167C5.68092 4.22164 5.48761 4.16299 5.3232 4.05312C5.15878 3.94325 5.03063 3.78708 4.95495 3.60438C4.87927 3.42168 4.85946 3.22067 4.89801 3.02672C4.93657 2.83276 5.03176 2.65458 5.17156 2.51472L7.29288 0.393397C7.48042 0.20586 7.73478 0.100513 8 0.100513C8.26521 0.100513 8.51956 0.20586 8.70709 0.393397L10.8284 2.51472C10.9679 2.65457 11.0629 2.83261 11.1013 3.02638C11.1398 3.22015 11.12 3.42097 11.0444 3.60349C10.9688 3.78602 10.8409 3.94206 10.6767 4.05195C10.5126 4.16185 10.3196 4.22065 10.122 4.22096L9.00055 4.22096L9.00055 6C9.00051 6.26516 8.89516 6.51946 8.70766 6.70696C8.52016 6.89446 8.26586 6.99981 8.0007 6.99985Z"
                                                fill="white"
                                            />
                                        </g>
                                    </svg>
                                </div>
                            }
                        </div>
                    }
                    @if (data.cardSettings.gallery.aspectRatio === aspectRatio.default) {
                        <div class="image-wrapper imageWrapper">
                            <picture [spFallbackImg]="formatImageFallbackURL(image)">
                                <img class="default-image" [src]="formatImageURL(image)" [alt]="image?.alt" />
                            </picture>
                        </div>
                    }
                </ng-template>
            }
        </swiper>
    }
    <div class="thumbs-swiper-container thumbsSwiperContainer product-card-thumbs">
        <swiper
            class="thumbsSwiper"
            (swiper)="setThumbs($event)"
            [spaceBetween]="gallerySettings.margin"
            [slidesPerView]="'auto'"
            [watchSlidesProgress]="true"
        >
            @for (image of cardImages; track $index; let i = $index) {
                <ng-template swiperSlide>
                    <div class="thumbWrapper">
                        <picture [spFallbackImg]="formatImageFallbackURL(image)">
                            @if (image?.srcSets?.length) {
                                @for (source of image.srcSets; track source) {
                                    <source [srcset]="source.url" [media]="source.media" />
                                }
                            }
                            <img class="thumbImage" [src]="formatImageURL(image)" [alt]="image?.alt" />
                        </picture>
                    </div>
                </ng-template>
            }
        </swiper>
    </div>
}
@if (isGalleryViewTypeFifth && !isDeviceMobile) {
    <div class="vertical-image-wrapper">
        @for (image of cardImages; track image) {
            <div #imagesContainer>
                <picture [spFallbackImg]="formatImageFallbackURL(image)">
                    @if (image?.srcSets?.length) {
                        @for (source of image.srcSets; track source) {
                            <source [srcset]="source.url" [media]="source.media" />
                        }
                    }
                    <img class="default-image" [src]="formatImageURL(image)" [alt]="image?.alt" />
                </picture>
            </div>
        }
    </div>
}
@if (isGalleryViewTypeSixth && !isDeviceMobile) {
    <div class="gridContainer">
        @for (item of masonryArrays; track $index; let columnIndex = $index) {
            <div>
                @for (image of item; track $index; let imageIndex = $index) {
                    <div class="gridItem">
                        @if (data.cardSettings.gallery.aspectRatio !== aspectRatio.default) {
                            <div
                                class="image-wrapper imageWrapper resizeble"
                                #resizeBox
                                mwlResizable
                                (resizeStart)="onResizeStart($event, resizeBox)"
                                (resizing)="onResizing($event, resizeBox)"
                                (resizeEnd)="
                                    onResizeEnd($event, resizeBox, imageIndex * masonryArrays.length + columnIndex)
                                "
                                [style.paddingTop.%]="
                                    getImagePaddingTop(cardImages[imageIndex * masonryArrays.length + columnIndex])
                                "
                            >
                                <picture [spFallbackImg]="formatImageFallbackURL(image)">
                                    @if (image?.srcSets?.length) {
                                        @for (source of image.srcSets; track source) {
                                            <source [srcset]="source.url" [media]="source.media" />
                                        }
                                    }
                                    <img
                                        #imageRef
                                        class="gridImage"
                                        (load)="
                                            resizeOnload(
                                                $event.target,
                                                resizeBox,
                                                imageIndex * masonryArrays.length + columnIndex
                                            )
                                        "
                                        [src]="formatImageURL(image)"
                                        [alt]="image?.alt"
                                        [style.objectPosition]="
                                            (image?.backgroundPositionX || 50) +
                                            '% ' +
                                            (image?.backgroundPositionY || 50) +
                                            '%'
                                        "
                                        (mousedown)="mouseDown($event, image)"
                                        (mousemove)="move($event, imageRef)"
                                        (mouseleave)="mouseUp(imageIndex * masonryArrays.length + columnIndex)"
                                        (mouseup)="mouseUp(imageIndex * masonryArrays.length + columnIndex)"
                                    />
                                </picture>
                                @if (data.cardSettings.gallery.aspectRatio === aspectRatio.manual) {
                                    <div class="dragHandle bottom" mwlResizeHandle [resizeEdges]="{ bottom: true }">
                                        <svg
                                            width="16"
                                            height="16"
                                            viewBox="0 0 16 16"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <g>
                                                <path
                                                    d="M8.7071 15.6066C8.51956 15.7941 8.26519 15.8995 7.99998 15.8995C7.73476 15.8995 7.48042 15.7941 7.29288 15.6066L5.17156 13.4853C5.03195 13.3455 4.93688 13.1674 4.89837 12.9736C4.85986 12.7798 4.87963 12.5789 4.95519 12.3963C5.00566 12.275 5.07913 12.1645 5.17156 12.0711C5.35906 11.884 5.61311 11.779 5.87796 11.779L6.99943 11.779L7.00085 10C6.99854 9.86724 7.02271 9.73535 7.07192 9.61202C7.12113 9.48869 7.19441 9.3764 7.28749 9.28169C7.38056 9.18699 7.49155 9.11175 7.614 9.0604C7.73646 9.00905 7.86792 8.98263 8.0007 8.98263C8.13348 8.98263 8.26493 9.00906 8.38739 9.06041C8.50984 9.11176 8.62085 9.18698 8.71393 9.28168C8.807 9.37639 8.88029 9.48869 8.9295 9.61202C8.97871 9.73535 9.00286 9.86724 9.00055 10L8.99984 11.7783L10.1213 11.7783C10.3191 11.7784 10.5124 11.837 10.6768 11.9469C10.8412 12.0568 10.9693 12.2129 11.045 12.3956C11.1207 12.5783 11.1405 12.7793 11.102 12.9733C11.0634 13.1672 10.9682 13.3454 10.8284 13.4853L8.7071 15.6066ZM8.0007 6.99985C7.73554 6.99981 7.48124 6.89446 7.29374 6.70696C7.10625 6.51946 7.00089 6.26516 7.00085 6L7.00014 4.22167L5.87867 4.22167C5.68092 4.22164 5.48761 4.16299 5.3232 4.05312C5.15878 3.94325 5.03063 3.78708 4.95495 3.60438C4.87927 3.42168 4.85946 3.22067 4.89801 3.02672C4.93657 2.83276 5.03176 2.65458 5.17156 2.51472L7.29288 0.393397C7.48042 0.20586 7.73478 0.100513 8 0.100513C8.26521 0.100513 8.51956 0.20586 8.70709 0.393397L10.8284 2.51472C10.9679 2.65457 11.0629 2.83261 11.1013 3.02638C11.1398 3.22015 11.12 3.42097 11.0444 3.60349C10.9688 3.78602 10.8409 3.94206 10.6767 4.05195C10.5126 4.16185 10.3196 4.22065 10.122 4.22096L9.00055 4.22096L9.00055 6C9.00051 6.26516 8.89516 6.51946 8.70766 6.70696C8.52016 6.89446 8.26586 6.99981 8.0007 6.99985Z"
                                                    fill="white"
                                                />
                                            </g>
                                        </svg>
                                    </div>
                                }
                            </div>
                        }
                        @if (data.cardSettings.gallery.aspectRatio === aspectRatio.default) {
                            <div class="image-wrapper imageWrapper">
                                <picture [spFallbackImg]="formatImageFallbackURL(image)">
                                    <img class="default-image" [src]="formatImageURL(image)" [alt]="image?.alt" />
                                </picture>
                            </div>
                        }
                    </div>
                }
            </div>
        }
    </div>
}
<!-- <ng-container *ngSwitchCase="CardKindViewType.third">
<swiper
  class="default-swiper"
  *ngIf="!isShowThumbs && isVerticalSwiper"
  [config]="swiperConfig"
  style="--swiper-navigation-color: {{ themeColorCss(gallerySettings.buttonColor) }}; --swiper-pagination-color: {{ themeColorCss(gallerySettings.buttonColor) }}"
  [rewind]="true"
  [navigation]="true"
  [pagination]="{ clickable: true, dynamicBullets: true }"
  [grabCursor]="true"
  [allowTouchMove]="false"
  (swiper)="setSwiper($event)"
  [spaceBetween]="0"
  [slidesPerView]="1"
  [direction]="'vertical'"
  [autoHeight]="true"
  >
  <ng-template swiperSlide *ngFor="let image of cardImages; index as i; trackBy: instanceId">
    <div *ngIf="data.cardSettings.gallery.aspectRatio !== aspectRatio.default"
      class="image-wrapper imageWrapper resizeble"
      #resizeBox
      mwlResizable
      (resizeStart)="onResizeStart($event, resizeBox)"
      (resizing)="onResizing($event, resizeBox)"
      (resizeEnd)="onResizeEnd($event, resizeBox, i)"
      [style.paddingTop.%]="getImagePaddingTop(cardImages[i])"
      >
      <img
        #imageRef
        class="gridImage"
        (load)="resizeOnload($event.target, resizeBox, i)"
        [src]="formatImageURL(image)"
        [alt]="image.alt"
        [style.objectPosition]="(image?.backgroundPositionX || 50) + '% ' + (image?.backgroundPositionY || 50) + '%'"
        (mousedown)="mouseDown($event, image)"
        (mousemove)="move($event, imageRef)"
        (mouseleave)="mouseUp(i)"
        (mouseup)="mouseUp(i)"
        />
      <div *ngIf="data.cardSettings.gallery.aspectRatio === aspectRatio.manual"
        class="dragHandle bottom" mwlResizeHandle [resizeEdges]="{ bottom: true }">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g>
            <path
              d="M8.7071 15.6066C8.51956 15.7941 8.26519 15.8995 7.99998 15.8995C7.73476 15.8995 7.48042 15.7941 7.29288 15.6066L5.17156 13.4853C5.03195 13.3455 4.93688 13.1674 4.89837 12.9736C4.85986 12.7798 4.87963 12.5789 4.95519 12.3963C5.00566 12.275 5.07913 12.1645 5.17156 12.0711C5.35906 11.884 5.61311 11.779 5.87796 11.779L6.99943 11.779L7.00085 10C6.99854 9.86724 7.02271 9.73535 7.07192 9.61202C7.12113 9.48869 7.19441 9.3764 7.28749 9.28169C7.38056 9.18699 7.49155 9.11175 7.614 9.0604C7.73646 9.00905 7.86792 8.98263 8.0007 8.98263C8.13348 8.98263 8.26493 9.00906 8.38739 9.06041C8.50984 9.11176 8.62085 9.18698 8.71393 9.28168C8.807 9.37639 8.88029 9.48869 8.9295 9.61202C8.97871 9.73535 9.00286 9.86724 9.00055 10L8.99984 11.7783L10.1213 11.7783C10.3191 11.7784 10.5124 11.837 10.6768 11.9469C10.8412 12.0568 10.9693 12.2129 11.045 12.3956C11.1207 12.5783 11.1405 12.7793 11.102 12.9733C11.0634 13.1672 10.9682 13.3454 10.8284 13.4853L8.7071 15.6066ZM8.0007 6.99985C7.73554 6.99981 7.48124 6.89446 7.29374 6.70696C7.10625 6.51946 7.00089 6.26516 7.00085 6L7.00014 4.22167L5.87867 4.22167C5.68092 4.22164 5.48761 4.16299 5.3232 4.05312C5.15878 3.94325 5.03063 3.78708 4.95495 3.60438C4.87927 3.42168 4.85946 3.22067 4.89801 3.02672C4.93657 2.83276 5.03176 2.65458 5.17156 2.51472L7.29288 0.393397C7.48042 0.20586 7.73478 0.100513 8 0.100513C8.26521 0.100513 8.51956 0.20586 8.70709 0.393397L10.8284 2.51472C10.9679 2.65457 11.0629 2.83261 11.1013 3.02638C11.1398 3.22015 11.12 3.42097 11.0444 3.60349C10.9688 3.78602 10.8409 3.94206 10.6767 4.05195C10.5126 4.16185 10.3196 4.22065 10.122 4.22096L9.00055 4.22096L9.00055 6C9.00051 6.26516 8.89516 6.51946 8.70766 6.70696C8.52016 6.89446 8.26586 6.99981 8.0007 6.99985Z"
              fill="white"
              />
          </g>
        </svg>
      </div>
    </div>

    <div *ngIf="data.cardSettings.gallery.aspectRatio === aspectRatio.default"
      class="image-wrapper imageWrapper">
      <img
        class="default-image"
        [src]="formatImageURL(image)"
        [alt]="image.alt"
        />
    </div>
  </ng-template>
</swiper>
</ng-container>
<ng-container *ngSwitchCase="CardKindViewType.fourth">
  <div class="image-swiper-vertical-container">
    <swiper
      [config]="thumbsParentConfig"
      *ngIf="thumbsSwiper"
      style="--swiper-navigation-color: {{ themeColorCss(gallerySettings.buttonColor) }}"
      [loop]="true"
      [loopedSlides]="loopedSlides"
      [navigation]="true"
      [grabCursor]="true"
      [spaceBetween]="0"
      [slidesPerView]="1"
      [allowTouchMove]="false"
      (swiper)="setSwiper($event)"
      [autoHeight]="data.cardSettings.gallery.aspectRatio === aspectRatio.default ? true : false">
      <ng-template swiperSlide *ngFor="let image of cardImages; index as i; trackBy: instanceId">
        <div *ngIf="data.cardSettings.gallery.aspectRatio !== aspectRatio.default"
          #resizeBox
          mwlResizable
          (resizeStart)="onResizeStart($event, resizeBox)"
          (resizing)="onResizing($event, resizeBox)"
          (resizeEnd)="onResizeEnd($event, resizeBox, i)"
          class="image-wrapper imageWrapper resizeble"
          [style.paddingTop.%]="getImagePaddingTop(cardImages[i])"
          >
          <img
            #imageRef
            class="gridImage"
            [src]="formatImageURL(image)"
            [alt]="image.alt"
            [style.objectPosition]="(image?.backgroundPositionX || 50) + '% ' + (image?.backgroundPositionY || 50) + '%'"
            (mousedown)="mouseDown($event, image)"
            (mousemove)="move($event, imageRef)"
            (mouseleave)="mouseUp(i)"
            (mouseup)="mouseUp(i)"
            />
          <div *ngIf="data.cardSettings.gallery.aspectRatio === aspectRatio.manual"
            class="dragHandle bottom" mwlResizeHandle [resizeEdges]="{ bottom: true }">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g>
                <path
                  d="M8.7071 15.6066C8.51956 15.7941 8.26519 15.8995 7.99998 15.8995C7.73476 15.8995 7.48042 15.7941 7.29288 15.6066L5.17156 13.4853C5.03195 13.3455 4.93688 13.1674 4.89837 12.9736C4.85986 12.7798 4.87963 12.5789 4.95519 12.3963C5.00566 12.275 5.07913 12.1645 5.17156 12.0711C5.35906 11.884 5.61311 11.779 5.87796 11.779L6.99943 11.779L7.00085 10C6.99854 9.86724 7.02271 9.73535 7.07192 9.61202C7.12113 9.48869 7.19441 9.3764 7.28749 9.28169C7.38056 9.18699 7.49155 9.11175 7.614 9.0604C7.73646 9.00905 7.86792 8.98263 8.0007 8.98263C8.13348 8.98263 8.26493 9.00906 8.38739 9.06041C8.50984 9.11176 8.62085 9.18698 8.71393 9.28168C8.807 9.37639 8.88029 9.48869 8.9295 9.61202C8.97871 9.73535 9.00286 9.86724 9.00055 10L8.99984 11.7783L10.1213 11.7783C10.3191 11.7784 10.5124 11.837 10.6768 11.9469C10.8412 12.0568 10.9693 12.2129 11.045 12.3956C11.1207 12.5783 11.1405 12.7793 11.102 12.9733C11.0634 13.1672 10.9682 13.3454 10.8284 13.4853L8.7071 15.6066ZM8.0007 6.99985C7.73554 6.99981 7.48124 6.89446 7.29374 6.70696C7.10625 6.51946 7.00089 6.26516 7.00085 6L7.00014 4.22167L5.87867 4.22167C5.68092 4.22164 5.48761 4.16299 5.3232 4.05312C5.15878 3.94325 5.03063 3.78708 4.95495 3.60438C4.87927 3.42168 4.85946 3.22067 4.89801 3.02672C4.93657 2.83276 5.03176 2.65458 5.17156 2.51472L7.29288 0.393397C7.48042 0.20586 7.73478 0.100513 8 0.100513C8.26521 0.100513 8.51956 0.20586 8.70709 0.393397L10.8284 2.51472C10.9679 2.65457 11.0629 2.83261 11.1013 3.02638C11.1398 3.22015 11.12 3.42097 11.0444 3.60349C10.9688 3.78602 10.8409 3.94206 10.6767 4.05195C10.5126 4.16185 10.3196 4.22065 10.122 4.22096L9.00055 4.22096L9.00055 6C9.00051 6.26516 8.89516 6.51946 8.70766 6.70696C8.52016 6.89446 8.26586 6.99981 8.0007 6.99985Z"
                  fill="white"
                  />
              </g>
            </svg>
          </div>
        </div>

        <div *ngIf="data.cardSettings.gallery.aspectRatio === aspectRatio.default"
          class="image-wrapper imageWrapper">
          <img
            class="default-image"
            [src]="formatImageURL(image)"
            [alt]="image.alt"
            />
        </div>
      </ng-template>
    </swiper>
    <div class="thumbs-swiper-vertical-container thumbsSwiperContainer">
      <swiper
        class="thumbsSwiper"
        (swiper)="setThumbs($event)"
        [spaceBetween]="gallerySettings.margin"
        [slidesPerView]="'auto'"
        [watchSlidesProgress]="true"
        [direction]="'vertical'"
        >
        <ng-template swiperSlide *ngFor="let image of cardImages; index as i; trackBy: instanceId">
          <div class="thumbWrapper">
            <img class="thumbImage" [src]="formatImageURL(image)" [alt]="image.alt" />
          </div>
        </ng-template>
      </swiper>
    </div>
  </div>
</ng-container>
<ng-container *ngSwitchCase="CardKindViewType.seventh">
  <div class="gridContainer">
    <div class="gridItem" *ngFor="let image of cardImages; index as i; trackBy: instanceId">
      <div *ngIf="data.cardSettings.gallery.aspectRatio !== aspectRatio.default"
        #resizeBox
        mwlResizable
        class="image-wrapper imageWrapper"
        (resizeStart)="onResizeStart($event, resizeBox)"
        (resizing)="onResizing($event, resizeBox)"
        (resizeEnd)="onResizeEnd($event, resizeBox, i)"
        [style.paddingTop.%]="getImagePaddingTop(cardImages[i])"
        >
        <img
          #imageRef
          class="gridImage"
          (load)="resizeOnload($event.target, resizeBox, i)"
          [src]="formatImageURL(image)"
          [alt]="image.alt"
          [style.objectPosition]="(image?.backgroundPositionX || 50) + '% ' + (image?.backgroundPositionY || 50) + '%'"
          (mousedown)="mouseDown($event, image)"
          (mousemove)="move($event, imageRef)"
          (mouseleave)="mouseUp(i)"
          (mouseup)="mouseUp(i)"
          />
        <div *ngIf="data.cardSettings.gallery.aspectRatio === aspectRatio.manual"
          class="dragHandle bottom" mwlResizeHandle [resizeEdges]="{ bottom: true }">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g>
              <path
                d="M8.7071 15.6066C8.51956 15.7941 8.26519 15.8995 7.99998 15.8995C7.73476 15.8995 7.48042 15.7941 7.29288 15.6066L5.17156 13.4853C5.03195 13.3455 4.93688 13.1674 4.89837 12.9736C4.85986 12.7798 4.87963 12.5789 4.95519 12.3963C5.00566 12.275 5.07913 12.1645 5.17156 12.0711C5.35906 11.884 5.61311 11.779 5.87796 11.779L6.99943 11.779L7.00085 10C6.99854 9.86724 7.02271 9.73535 7.07192 9.61202C7.12113 9.48869 7.19441 9.3764 7.28749 9.28169C7.38056 9.18699 7.49155 9.11175 7.614 9.0604C7.73646 9.00905 7.86792 8.98263 8.0007 8.98263C8.13348 8.98263 8.26493 9.00906 8.38739 9.06041C8.50984 9.11176 8.62085 9.18698 8.71393 9.28168C8.807 9.37639 8.88029 9.48869 8.9295 9.61202C8.97871 9.73535 9.00286 9.86724 9.00055 10L8.99984 11.7783L10.1213 11.7783C10.3191 11.7784 10.5124 11.837 10.6768 11.9469C10.8412 12.0568 10.9693 12.2129 11.045 12.3956C11.1207 12.5783 11.1405 12.7793 11.102 12.9733C11.0634 13.1672 10.9682 13.3454 10.8284 13.4853L8.7071 15.6066ZM8.0007 6.99985C7.73554 6.99981 7.48124 6.89446 7.29374 6.70696C7.10625 6.51946 7.00089 6.26516 7.00085 6L7.00014 4.22167L5.87867 4.22167C5.68092 4.22164 5.48761 4.16299 5.3232 4.05312C5.15878 3.94325 5.03063 3.78708 4.95495 3.60438C4.87927 3.42168 4.85946 3.22067 4.89801 3.02672C4.93657 2.83276 5.03176 2.65458 5.17156 2.51472L7.29288 0.393397C7.48042 0.20586 7.73478 0.100513 8 0.100513C8.26521 0.100513 8.51956 0.20586 8.70709 0.393397L10.8284 2.51472C10.9679 2.65457 11.0629 2.83261 11.1013 3.02638C11.1398 3.22015 11.12 3.42097 11.0444 3.60349C10.9688 3.78602 10.8409 3.94206 10.6767 4.05195C10.5126 4.16185 10.3196 4.22065 10.122 4.22096L9.00055 4.22096L9.00055 6C9.00051 6.26516 8.89516 6.51946 8.70766 6.70696C8.52016 6.89446 8.26586 6.99981 8.0007 6.99985Z"
                fill="white"
                />
            </g>
          </svg>
        </div>
      </div>
      <div *ngIf="data.cardSettings.gallery.aspectRatio === aspectRatio.default"
        class="image-wrapper imageWrapper">
        <img
          class="default-image"
          [src]="formatImageURL(image)"
          [alt]="image.alt"
          />
      </div>
    </div>
  </div>
</ng-container> -->
